<template>
    <dynamicLink v-if="$store.getters.getModalActive" :type="$store.getters.getModalCustomComponent" />
</template>

<script>

import dynamicLink from '../components/dynamicLink'

export default {
  name: 'modal',
  components: {    
    dynamicLink
  },
  props: {
  },
  data () {
    return {
    }
  }
}
</script>